<script lang="ts" setup>
/* eslint-disable vue/max-len */
// The hinged top flap of the envelope. Rendered as its own SVG layer
// in `Envelope.vue` so it can rotate around its top edge
// independently of the body — matching the technique from the design
// reference (rotateX on a separate plane, with backface tint shown
// once the flap passes 90°).
//
// `fill="currentColor"` so the parent controls hue via
// `color: var(--env-color)`.
</script>

<template>
  <svg
    class="env-flap-svg"
    viewBox="0 0 320 170"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    aria-hidden="true"
  >
    <g filter="url(#env-flap-filter)">
      <path
        d="M146.873 167.996C155.4 170.668 164.601 170.668 173.128 167.996C184.196 164.528 193.412 154.353 211.844 134.004L272.071 67.5111C303.699 32.5925 319.711 14.9129 320 -3.79301e-06H0C0.289383 14.9129 16.302 32.5924 47.9302 67.5111L108.156 134.004C126.588 154.354 135.805 164.528 146.873 167.996Z"
        fill="currentColor"
      />
      <!--
        Subtle top-down highlight gradient on the front face of the
        flap — makes the closed flap read as a single folded panel.
      -->
      <path
        d="M146.873 167.996C155.4 170.668 164.601 170.668 173.128 167.996C184.196 164.528 193.412 154.353 211.844 134.004L272.071 67.5111C303.699 32.5925 319.711 14.9129 320 -3.79301e-06H0C0.289383 14.9129 16.302 32.5924 47.9302 67.5111L108.156 134.004C126.588 154.354 135.805 164.528 146.873 167.996Z"
        fill="url(#env-flap-gradient)"
        fill-opacity="0.2"
        style="mix-blend-mode: multiply;"
      />
      <!--
        Back-face wash — sits at zero opacity normally and the parent
        flips it on once the flap rotates past 90° (so the inside of
        the open flap reads a touch darker than the outside).
      -->
      <path
        class="env-flap-back-tint"
        d="M146.873 167.996C155.4 170.668 164.601 170.668 173.128 167.996C184.196 164.528 193.412 154.353 211.844 134.004L272.071 67.5111C303.699 32.5925 319.711 14.9129 320 -3.79301e-06H0C0.289383 14.9129 16.302 32.5924 47.9302 67.5111L108.156 134.004C126.588 154.354 135.805 164.528 146.873 167.996Z"
        fill="#000000"
        fill-opacity="0.22"
      />
    </g>
    <defs>
      <filter
        id="env-flap-filter"
        x="-0.7"
        y="0"
        width="321.4"
        height="171.7"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="1"/>
        <feGaussianBlur stdDeviation="0.35"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
      <linearGradient
        id="env-flap-gradient"
        x1="160"
        y1="137.235"
        x2="160"
        y2="-28.3569"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.24" stop-color="white"/>
        <stop offset="0.3" stop-color="#F6F6F6"/>
        <stop offset="0.4" stop-color="#E0E0E0"/>
        <stop offset="0.52" stop-color="#BBBBBB"/>
        <stop offset="0.65" stop-color="#898989"/>
        <stop offset="0.81" stop-color="#484848"/>
        <stop offset="0.96"/>
      </linearGradient>
    </defs>
  </svg>
</template>

<style scoped lang="scss">
.env-flap-svg {
  display: block;
  height: 100%;
  overflow: visible;
  width: 100%;
}

.env-flap-back-tint {
  opacity: 0;
}
</style>
